import { IHttpService, ILocationService, IScope } from 'angular';
import moment from 'moment-timezone';
import { User } from 'ng/src/app/users/shared/user.model';
import { CookieService } from "ngx-cookie-service";
import { LogBookRootScopeService } from "../shared/model/app.model";

angular.module('logbook')
	.controller('signup', ['$scope', '$rootScope', '$http', '$location', 'cookieService',
		function($scope: IScope, $rootScope: LogBookRootScopeService, $http: IHttpService, $location: ILocationService, cookieService: CookieService) {
			$scope.enabled = !(cookieService.get('hide-signup') === 'true' || $location.search()['signup'] === 'false');
			
			$scope.backToRoot = () => {
				$location.path('/');
			}
			
			$scope.submit = () => {
				delete $scope.error;

				$http.get<{ error: string } | ''>('api/checkEmailAddress', {
					params: {
						email: $scope.user.newUserData.email
					}
				})
				.then(result => {
					if (result.data == '')
						$http.post('/api/logBookUsers', $scope.user, {
							noErrorPopup: true
						})
						.then(
							() => {
								$rootScope.authenticate(() => {
									if ($rootScope.user?.validationRequired) {
										$scope.email = $scope.user.newLogBookUserEmail;
										$scope.submitted = true;
									}
									else
										$location.url('/logs');

								}, '/signup');
							},
							error => $scope.error = error
						);
					else
						$scope.error = result.data.error;
				});
			}

			$scope.checkLogin = () => {
				delete $scope.existingLogin;
				delete $scope.noExistingLogin;

				$http.get<User | ''>('api/user').then(result => {
					if (result.data == '')
						$scope.noExistingLogin = true;
					else
						$scope.existingLogin = result.data.user;
				});
			};
			
			$scope.checkLogin();

			$scope.cancelSignup = () => {
				$location.url('/');
			};

			$scope.logout = () => {
				$http.post('logout', null).then($scope.checkLogin);
			};

			$scope.user = {
				newUserData: {
					dummy1: 'logbook',
					timeZone: moment.tz.guess()
				}
			};

			$scope.email = $location.search().email;

			if ($scope.email)
				$scope.user.newUserData.email = $scope.email;
			
			if ($location.search().code)
				$scope.user.newUserData.emailValidationCode = $location.search().code;
			
			$scope.submitted = $location.search().submitted;

			$scope.userFields = [
			{
				key: "newUserData.email",
				type: "input",
				templateOptions: {
					type: 'email',
					label: 'Email Address',
					required: true,
					disabled: $scope.email
				}
			},
			{
				key: "firstName",
				type: "input",
				className: "test",
				templateOptions: {
					label: 'First Name',
					required: true
				}
			},
			{
				key: "lastName",
				type: "input",
				templateOptions: {
					label: 'Last Name',
					required: true
				}
			},
			{
				key: 'newUserData.password',
				type: 'input',
				validators: {
					password: {
						expression: function(value: any) {
							// If the field has not been used for input, allow to continue.
							if (typeof value !== 'string') return true;
							
							if (!(/.*[a-z]/g).test(value)) {
								return false;
							}
							if (!(/.*[A-Z].*/g).test(value)) {
								return false;
							}
							if (!(/.[0-9].*/g).test(value)) {
								return false;
							}
							if (!(/.{8,}/g).test(value)) {
								return false;
							}
							return true;
						}
					}
				},
				validation: {
					messages: {
						password:  () => 'Password must be more than 8 characters, contain an upper and lower case letter and a number.',
					}
				},
				templateOptions: {
					type: 'password',
					label: 'Password',
					placeholder: '8 characters minimum',
					required: true,
					minlength: 8
				}
			}];
		}
	]);